var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isLoading)?_c('Loading'):_c('router-view'),_c('input',{staticClass:"btnOneTrust",attrs:{"name":"btnOneTrust","type":"button","id":"btnOneTrust","value":"Meine Cookie Auswahl","onclick":"Optanon.ToggleInfoDisplay();","aria-label":"Cookie Button"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }